import React, {forwardRef}  from "react"
import styled from "styled-components";
import Button from "./Button";

const StdBtn = styled.button`

    transition: all 0.3s ease; /* 애니메이션 천천히 */
    
    color: ${props => props.$SelYn ? '#FFFFFF' : '#004D74'};
    background-color: ${props => props.$SelYn ? '#004D74' : '#FFFFFF'};
  
    border-style: solid;
    border-width: ${props => props.$SelYn ? '0' : '1px' };
    border-color: ${props => props.$SelYn ? '' : '#E0E0E0'};

    border-radius: 2px;
  
    width: ${props => props.$addStyle?.width || "98px"};
    height: ${props => props.$addStyle?.height || "32px"};

    //font: 500 13px/1.5 Pretendard;
    
    font-size: ${props => ({'sm': '13px', 'md': '15px', 'lg': '16px', 'xl': '18px'}[props.$size])};
    font-weight: ${props => ({'sm': '500', 'md': '500', 'lg': '600', 'xl': '700'}[props.$size])};
  
    font-style: normal;        
    font-family: 'Pretendard', sans-serif;
`;

const StdDiv = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 8px;
`;

const SwitchGroup = forwardRef((props, ref) => {

    const {variant="Switch", size ="sm", addStyle={}, value, onClick, items={}, isDisabled=false } = props;

    return (
        <StdDiv>
            {Object.entries(items).map(([key, val]) => (
                <StdBtn
                    $variant={variant}
                    $size={size}
                    $addStyle={addStyle}
                    key={key}
                    $SelYn={String(value) === String(val)}
                    onClick={() => !isDisabled && onClick(val)}
                    ref={ref}
                >
                    {key}
                </StdBtn>
            ))}
        </StdDiv>
    );
});

export default SwitchGroup;
